import { StatusType } from '../availabilityUser/constants';

export enum AvailabilitySocketConnectionState {
  Disabled = 'disabled',
  Connecting = 'connecting',
  Connected = 'connected',
  Reconnecting = 'reconnecting',
  Disconnected = 'disconnected',
}

export enum AvailabilitySocketMessageType {
  InitialState = 'initial_state',
  ActivityUpdate = 'activity_update',
  InterruptionDelivered = 'interruption_delivered',
  InterruptionCancelled = 'interruption_cancelled',
  InterruptionResponseStatusChanged = 'interruption_response_status_changed',
  InitialInterruptions = 'initial_interruptions',
  FocusSchedulesUpdated = 'focus_schedules_updated',
  NotificationDelivered = 'notification_delivered',
  ChangeUserStatus = 'change_user_status',
  Unknown = 'unknown',
  ParseError = 'parse_error',
}

export type AvailabilitySocketInboundMessageType = Exclude<
  AvailabilitySocketMessageType,
  | AvailabilitySocketMessageType.ChangeUserStatus
  | AvailabilitySocketMessageType.Unknown
  | AvailabilitySocketMessageType.ParseError
>;

export type AvailabilitySocketContextValue = Readonly<{
  connectionState: AvailabilitySocketConnectionState;
  sendMessage: (messageType: AvailabilitySocketMessageType, payload?: unknown) => Promise<void>;
}>;
export type AvailabilitySocketEnvelope = Readonly<{
  type: string;
  request_id?: string;
  timestamp?: number;
  payload?: unknown;
}>;

type AvailabilitySocketMeta = Readonly<{
  request_id?: string;
  timestamp?: number;
}>;

type AvailabilitySocketKnownMessage = Readonly<{
  type: AvailabilitySocketInboundMessageType;
  meta: AvailabilitySocketMeta;
  payload: unknown;
}>;

type AvailabilitySocketUnknownMessage = Readonly<{
  type: AvailabilitySocketMessageType.Unknown;
  meta: AvailabilitySocketMeta;
  messageType: string;
  payload: unknown;
}>;

type AvailabilitySocketParseErrorMessage = Readonly<{
  type: AvailabilitySocketMessageType.ParseError;
  raw: string;
  error: string;
}>;

export type AvailabilitySocketMessage =
  | AvailabilitySocketKnownMessage
  | AvailabilitySocketUnknownMessage
  | AvailabilitySocketParseErrorMessage;

export type AvailabilitySocketInitialStatePayload = Readonly<{
  id?: string;
  user?: AvailabilitySocketUserPayload | null;
  status?: AvailabilitySocketActivityPayload | null;
}>;

type AvailabilitySocketUserPayload = Readonly<{
  id?: string;
  employeeAlias?: string;
  email?: string;
  name?: string;
  status?: StatusType | null;
}>;

export type AvailabilitySocketActivityPayload = Readonly<{
  employeeId?: string;
  employeeEmail?: string;
  employeeName?: string;
  state?: StatusType | null;
  status?: StatusType | null;
  confidence?: number;
  since?: number;
  dominantSourcesJson?: string;
  explain?: string;
  updatedAt?: number;
  id?: string;
}>;
